import {Fill, Stroke, Style, Text} from "ol/style";
import Circle from "ol/style/Circle";

export const closedSectorStyle = (style) => {
    return [style[0], style[1], new Style({
        fill: new Fill({
            color: 'rgba(111, 66, 193, 0.4)',
        }),
        stroke: new Stroke({
            color: '#6F42C1'
        }),
    })];
}

export const busySectorStyle = (style) => {
    return [style[0], style[1], new Style({
        fill: new Fill({
            color: 'rgba(175, 22, 24, 0.4)',
        }),
        stroke: new Stroke({
            color: '#af1618'
        }),
    })];
}

export const sectorsStyle = (feature, overflow = null) => {

    let description = feature.get('description') ?? '';

    let style = [ new Style({
        stroke: new Stroke({
            color: 'rgb(252, 207, 3)',
        }),
        fill: new Fill({
            color: 'rgba(17, 78, 0, 0.2)'
        }),
        text: new Text({
            textAlign: 'center',
            textBaseline: 'middle',
            text: feature.get('name'),
            fill: new Fill({color: 'white'}),
            stroke: new Stroke({color: 'black', width: 2}),
            placement: 'point',
            font: '14px sans-serif',
            overflow: overflow === false ? false : 'overflow',
        }),
    }), new Style({
        text: new Text({
            textAlign: 'center',
            textBaseline: 'middle',
            offsetY: 15,
            text: description.length < 52 && description.length > 0 ? '(' + description + ')' : description.length > 0 ? '(' + description.slice(52) + '...)' : '',
            fill: new Fill({color: 'white'}),
            stroke: new Stroke({color: 'black', width: 2}),
            placement: 'point' ,
            font: '11px sans-serif',
            overflow: false,
    })})
    ];

    let data = feature.get('sector-data');

    if(data) {
        if (data.book_records && data.book_records.length > 0) {
            return busySectorStyle(style, feature);
        }

        if ((data.shutdowns && data.shutdowns.length > 0) || data.district_shutdown_from) {
            return closedSectorStyle(style, feature);
        }
    }

    return style;
}

export const farSectorsStyle = (feature) => {
    return new Style({
        stroke: new Stroke({
            color: 'rgb(252, 207, 3)'
        }),
        fill: new Fill({
            color: 'rgba(17, 78, 0, 0.2)'
        }),
        text: new Text({
            textAlign: 'center',
            textBaseline: 'middle',
            text: feature.get('name'),
            fill: new Fill({color: 'white'}),
            stroke: new Stroke({color: 'black', width: 2}),
            placement: 'point',
            font: '14px sans-serif',
            overflow: false,
        }),
    })
}

export const drawSectorsStyle = new Style({
    image: new Circle({
        fill: new Fill({
            color: 'rgba(17, 78, 0, 0.8)'
        }),
        stroke: new Stroke({
            color: 'rgba(38,171,5,0.8)'
        }),
        radius: 5
    }),
    stroke: new Stroke({
        color: '#114e00'
    }),
    fill: new Fill({
        color: 'rgba(17, 78, 0, 0.2)'
    })
});
